import React, { useEffect, useRef, useState } from "react";
import { NumericFormat } from "react-number-format";
import { useLocation } from 'react-router-dom';
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Icon,
  RSelect,
} from "../../components/Component";
import DatePicker from "../../components/range-date-picker/RangeDatePicker";
import Table from "../../components/react-table/Table";
import { DELETE, GET } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import * as moment from "moment";
import queryString from 'query-string';
import ReactSelect from "react-select";
import ReactToPrint from "react-to-print";
import { getToken } from "../../helper/auth";
import { INVENTORY_FUEL_CATEGORY, renderPageStyle } from "../../utils/Utils";
import ExchangeInventory from "./ExchangeInventory";

import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { toast } from "react-toastify";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  UncontrolledDropdown
} from "reactstrap";
import { inventoryOutInsideColTable } from "../../utils/col-table";
import SignPrintComponent from '../pn/Components/SignPrintComponent';

const INVENTORY_FUEL_CATEGORY_OPTIONS = Object.keys(INVENTORY_FUEL_CATEGORY).map((c) => ({
  label: INVENTORY_FUEL_CATEGORY[c],
  value: c,
}));

const InventoryOutInside = () => {
  const printRef = useRef();

  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const [data, setData] = useState([]);
  const [summary, setSummary] = useState({});
  const [loading, setLoading] = useState(false);
  const [deleteId, setDeleteId] = useState();

  const [timeNow, setTimeNow] = useState();
  const [smOption, setSmOption] = useState(false);
  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [truckOptions, setTruckOptions] = useState([]);
  const [driverOptions, setDriverOptions] = useState([]);

  const [rangeDate, setRangeDate] = useState({
    startDate: searchParams.get('startDate') ? moment(searchParams.get('startDate')).startOf('days').toDate() : moment().startOf("months").toDate(),
    endDate: searchParams.get('endDate') ? moment(searchParams.get('endDate')).endOf('days').toDate() : moment().endOf('days').toDate(),
  });

  const [filter, setFilter] = useState({
    category: searchParams.get('category') || 'OIL',
    warehouseId: searchParams.get("warehouseId") || undefined,
    truckId: searchParams.get("truckId") || undefined,
    userId: searchParams.get('userId') || undefined,

  });

  const [view, setView] = useState({
    edit: false,
    add: false,
    isDelete: false,
    isScan: false,
  });


  const onRangeChange = (dates) => {
    const [startDate, endDate] = dates;
    setRangeDate({
      startDate: startDate ? moment(startDate)?.startOf('days').toDate() : startDate,
      endDate: endDate ? moment(endDate)?.endOf('days').toDate() : endDate
    });
    if (startDate && endDate) {
      setTimeNow(moment().valueOf());
    }
  };

  const colTable = inventoryOutInsideColTable({
    actionCol: [
      {
        Header: "Xác nhận",
        accessor: (item) =>
          item.agreedAt
            ? (
              "Đã xác nhận"
            )
            : item.truckId
              ? (
                <Button
                  className={"btn btn-primary"}
                  onClick={(ev) => {
                    ev.preventDefault();
                    history.push(`/inventory-out-inside/${item.id}`)
                  }}
                >
                  Hiện Scan
                </Button>
              ) : (
                "Chuyển nội bộ"
              ),
      },
      {
        Header: "Hành động",
        accessor: (item) => (
          <ul className="nk-tb-actions gx-1">
            <li>
              <UncontrolledDropdown>
                <DropdownToggle
                  tag="a"
                  className="btn btn-icon dropdown-toggle btn-trigger"
                >
                  <Icon name="more-h"></Icon>
                </DropdownToggle>
                <DropdownMenu right>
                  <ul className="link-list-opt no-bdr">
                    {item.truckId && (<>
                      <li>
                        <DropdownItem
                          tag="a"
                          href="#dropdown"
                          onClick={(ev) => {
                            ev.preventDefault();
                            history.push(`/inventory-out-inside/${item.id}`)
                          }}
                        >
                          <Icon name="edit"></Icon>
                          <span>Sửa</span>
                        </DropdownItem>
                      </li>
                      <li>
                        <DropdownItem
                          tag="a"
                          href="#dropdown"
                          onClick={(ev) => {
                            ev.preventDefault();
                            history.push(`/inventory-out-inside/add?duplicateId=${item.id}`)
                          }}
                        >
                          <Icon name="copy"></Icon>
                          <span>Nhân bản</span>
                        </DropdownItem>
                      </li>
                    </>
                    )}
                    <li>
                      <DropdownItem
                        tag="a"
                        href="#dropdown"
                        onClick={(ev) => {
                          ev.preventDefault();
                          setDeleteId(item.id);
                          toggle("isDelete");
                        }}
                      >
                        <Icon name="trash" className="text-danger"></Icon>
                        <span>Xoá</span>
                      </DropdownItem>
                    </li>
                  </ul>
                </DropdownMenu>
              </UncontrolledDropdown>
            </li>
          </ul>
        ),
      },
    ]
  })


  useEffect(() => {
    GET(
      "truck", {}, true
    ).then((resp) => {
      const { data } = resp;
      if (data && data.rows && data.rows.length) {
        setTruckOptions(
          data.rows.map((c) => ({
            label: c.id,
            value: c.id,
            data: c,
          }))
        );
      }
    });

    GET("/warehouse", {}, true).then((resp) => {
      setWarehouseOptions(
        resp.data?.rows?.map(
          (c) =>
          ({
            label: c.name,
            value: c.id,
            data: c,
          })
        )
      );
    });

    GET("/user/", {}, true).then((resp) => {
      const { data } = resp;
      setDriverOptions(
        data.map((c) => ({
          label: c.name,
          value: c.id,
          data: c,
        }))
      );
    });
  }, [])

  // Changing state value when searching name
  useEffect(() => {
    const newParams = new URLSearchParams({
      ...rangeDate,
      ...(filter.warehouseId ? { warehouseId: filter.warehouseId } : {}),
      ...(filter.category ? { category: filter.category } : {}),
      ...(filter.truckId ? { truckId: filter.truckId } : {}),
      ...(filter.userId ? { userId: filter.userId } : {}),

    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })

    setLoading(true);
    setData([]);
    let params = {
      startDate: moment(rangeDate.startDate).format("YYYY-MM-DD"),
      endDate: moment(rangeDate.endDate).format("YYYY-MM-DD"),
      location: 'INSIDE',
      ...(filter.warehouseId ? { warehouseId: filter.warehouseId } : {}),
      ...(filter.category ? { category: filter.category } : {}),
      ...(filter.truckId ? { truckId: filter.truckId } : {}),
      ...(filter.userId ? { userId: filter.userId } : {}),

    };

    GET(`inventory/out-inside-transaction`, params, true)
      .then(({ data: { rows, summary } }) => {
        setData(rows);
        setSummary(summary);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [timeNow, filter]);

  // toggle function to view order details
  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  // function to close the form modal
  const onFormCancel = () => {
    setView({ add: false, edit: false, isDelete: false, isScan: false });
    setDeleteId();
  };


  const resetData = () => {
    onFormCancel();
    setTimeNow(moment().valueOf());
  };

  const deleteInventoryIn = (id) => {
    if (!id) {
      return;
    }
    DELETE(`inventory/out-inside-transaction/${id}`, {}, true)
      .then((res) => {
        toast.success("Xóa thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };

  const exportExcel = () => {
    const params = {
      startDate: moment(rangeDate.startDate).format("YYYY-MM-DD"),
      endDate: moment(rangeDate.endDate).format("YYYY-MM-DD"),
      location: 'INSIDE',
      ...(filter.warehouseId ? { warehouseId: filter.warehouseId } : {}),
      ...(filter.category ? { category: filter.category } : {}),
      ...(filter.truckId ? { truckId: filter.truckId } : {}),
      ...(filter.userId ? { userId: filter.userId } : {}),
      token: getToken(),
    }
    const url = `${process.env.REACT_APP_API_URL}/api/v1/inventory/out-inside-transaction-excel?${queryString.stringify(params)}`;
    window.open(url, '_blank')
  };

  const exportGroupUserAndTruckExcel = () => {
    const params = {
      startDate: moment(rangeDate.startDate).format("YYYY-MM-DD"),
      endDate: moment(rangeDate.endDate).format("YYYY-MM-DD"),
      location: 'INSIDE',
      ...(filter.warehouseId ? { warehouseId: filter.warehouseId } : {}),
      ...(filter.category ? { category: filter.category } : {}),
      ...(filter.truckId ? { truckId: filter.truckId } : {}),
      ...(filter.userId ? { userId: filter.userId } : {}),
      token: getToken(),
    }
    const url = `${process.env.REACT_APP_API_URL}/api/v1/inventory/out-transaction-group-user-and-truck-excel?${queryString.stringify(params)}`;
    window.open(url, '_blank')
  };

  return (
    <React.Fragment>
      <Head title="Quản lý tổng kho"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Đổ nguyên liệu</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap">
                        <DatePicker
                          selected={rangeDate.startDate}
                          startDate={rangeDate.startDate}
                          onChange={onRangeChange}
                          endDate={rangeDate.endDate}
                          maxDate={new Date()}
                          selectsRange
                          className="form-control date-picker"
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <ReactSelect
                          placeholder="Tìm kiếm loại"
                          classNamePrefix="form-control"
                          options={INVENTORY_FUEL_CATEGORY_OPTIONS}
                          value={INVENTORY_FUEL_CATEGORY_OPTIONS.find(
                            (c) => c.value === filter.category
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              category: (val && val.value) || "",
                            })
                          }
                        />
                      </div>
                    </li>


                    <li>
                      <div className="form-control-wrap" style={{ width: 150 }}>
                        <RSelect
                          isClearable
                          classNamePrefix="form-control"
                          placeholder="Lọc theo xe"
                          options={truckOptions}
                          value={truckOptions.find(
                            (c) => c.value === filter.truckId
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              truckId: val?.value || undefined
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <ReactSelect
                          isClearable
                          placeholder="Tìm kiếm tài xế"
                          classNamePrefix="form-control"
                          options={driverOptions}
                          value={driverOptions.find(
                            (c) => c.value === filter.userId
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              userId: (val && val.value) || "",
                            })
                          }
                        />
                      </div>
                    </li>

                    <li>
                      <div className="form-group">
                        <div className="form-control-wrap">
                          <RSelect
                            isClearable
                            placeholder={"Lọc theo kho"}
                            options={warehouseOptions}
                            value={warehouseOptions.find((c) => c.value === filter.warehouseId) || null}
                            onChange={(val) => {
                              setFilter({
                                ...filter,
                                warehouseId: val?.value || undefined,
                              });
                            }}
                          />
                        </div>
                      </div>
                    </li>
                  </ul>
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li className="">
                      <div className="">
                        <Button
                          className=""
                          color="primary"
                          onClick={() => {
                            history.push(`/inventory-out-inside/add`)
                          }}
                        >
                          <Icon name="plus"></Icon>
                          <span>Thêm đổ dầu</span>
                        </Button>
                      </div>
                    </li>
                    <li>
                      <div>
                        <ReactToPrint
                          trigger={() => <Button className={`btn-secondary`}>In</Button>}
                          content={() => printRef.current}
                          pageStyle={``}
                        />
                        <Button onClick={exportExcel} className="btn-secondary ml-3">
                          <span>Xuất excel</span>
                        </Button>

                        <Button onClick={exportGroupUserAndTruckExcel} className="btn-secondary ml-3">
                          <span>Xuất excel nhóm tài xế và xe</span>
                        </Button>
                      </div>
                    </li>
                    <li>
                      <ExchangeInventory resetData={() => {
                        setTimeNow(moment().valueOf());
                      }} />
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="my-3" ref={printRef}>
                  <h5 className="text-center mt-2 mb-2">Báo cáo đổ {INVENTORY_FUEL_CATEGORY[filter.category]}</h5>
                  <h6 className="text-center mt-2 mb-2">Từ {moment(rangeDate.startDate).format('DD-MM-YYYY')} đến {moment(rangeDate.endDate).format('DD-MM-YYYY')} </h6>
                  <style>{renderPageStyle({
                    hiddenActionCol: true,
                    orientation: 'portrait'
                  })}</style>
                  <Table
                    loading={loading}
                    columns={colTable}
                    data={data}
                    notShowPagi={true}
                    headerRow={(
                      <tr className="nk-tb-item odd font-weight-bold">
                        <td colSpan={1} className="nk-tb-col">
                          <span> Tổng kết ({data?.length || 0} giao dịch) </span>
                        </td>
                        <td className="nk-tb-col text-right">
                          <NumericFormat
                            value={summary.quantity || 0}
                            displayType={'text'}
                            decimalScale={2}
                            thousandSeparator={','}
                            thousandsGroupStyle="thousand"
                          />
                        </td>
                        <td></td>
                        <td className="nk-tb-col text-right">
                          <NumericFormat
                            value={summary.total || 0}
                            displayType={'text'}
                            decimalScale={2}
                            thousandSeparator={','}
                            thousandsGroupStyle="thousand"
                          />
                        </td>
                        <td colSpan={4}> </td>
                        <td></td>
                      </tr>
                    )}
                  ></Table>
                  <SignPrintComponent />
                </div>
              </div>
            </div>
          </div>
        </Block>

        <Modal isOpen={view.isDelete} toggle={() => onFormCancel()} >
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></Icon>
              <h4 className="nk-modal-title">
                Bạn có chắc muốn xoá giao dịch này không ?{" "}
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  onClick={(ev) => {
                    ev.preventDefault();
                    deleteInventoryIn(deleteId);
                  }}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};

export default InventoryOutInside;
